<template>
  <div
    :class="{
      opened: opened.indexOf(this.boxName) >= 0,
      'last-active': opened.indexOf(this.boxName) === opened.length - 1
    }"
    class="side-box__inner"
  >
    <div class="side-box__header d-flex justify-content-between align-items-center">
      <div class="atom-back atom-back--gray" @click="toggleSaveConfirmation()">
        <div class="atom-back__inner d-flex align-items-center">
          <img src="@/assets/icons/arrows/arr-gray-left.svg" />
          <span>{{ $t("zpet") }}</span>
        </div>
      </div>
      <button class="btn btn-primary" @click="checkInputs()">
        <div class="atom-icon" @click="changedEvent">
          <img src="@/assets/icons/actions/ico-btn-ulozit.svg" />
        </div>
        {{ $t("BTN_SEND_NEW_HW_REQUEST") }}
      </button>
    </div>
    <div class="side-box__title">
      <h2>{{ $t("TITLE_NEW_HW_REQUEST") }}</h2>
    </div>
    <div class="side-box__content">
      <div class="my-4">
        <div class="side-box__row d-flex align-items-top mt-3">
          <span class="side-box__content__label">{{ $t("LABEL_HW_REQUEST_TEXT") }}</span>
          <div
            :class="{
              'has-error': isError && !newRequest.description
            }"
            class="side-box__content__input custom-control__custom-input ml-3"
          >
            <textarea
              v-model="newRequest.description"
              :placeholder="$t('PLACEHOLDER_HW_REQUEST_TEXT')"
              autofocus
              class="w-100"
              maxlength="255"
              rows="10"
              type="text"
              @change="changedEvent"
            />
          </div>
        </div>
      </div>
    </div>

    <SaveConfirmationModal
      :opened="openedSaveConfirmation"
      :text="'chceteUlozitProvedeneZmeny'"
      @close="toggleSaveConfirmation"
      @no="closeBox()"
      @yes="sendRequest()"
    />

    <div v-if="errorsToTranslate.length > 0">
      <ErrorModal :centered="true" :errors="errorsToTranslate" :opened="openedError" @close="openedError = false" />
    </div>
    <InfoModal :centered="true" :opened="openedInfoConfirmation" :text="infoText" @close="toggleInfo" />
  </div>
</template>

<script>
import axios from "axios"
import SaveConfirmationModal from "@/components/confirmations/save.vue"
import ErrorModal from "@/components/confirmations/error.vue"
import InfoModal from "@/components/confirmations/info.vue"
import { useProjectStore } from "@/store/modules/project"
import { useAuthStore } from "@/store/modules/auth"
import { useCustomerStore } from "@/store/modules/customer"

export default {
  components: {
    SaveConfirmationModal,
    ErrorModal,
    InfoModal
  },
  props: {
    opened: Array
  },
  setup() {
    const projectStore = useProjectStore()
    const customerStore = useCustomerStore()
    const authStore = useAuthStore()

    return { projectStore, authStore, customerStore }
  },
  data() {
    return {
      infoText: "",
      openedError: false,
      openedInfoConfirmation: false,
      openedSaveConfirmation: false,
      boxName: "hwRequest",
      errorsToTranslate: [],
      isError: false,
      projectId: this.$route.params.projectId,
      customerId: this.$route.params.customerId,
      newRequest: {
        description: ""
      }
    }
  },
  computed: {
    apiUser() {
      return this.authStore.apiUser
    },
    project() {
      return this.projectStore.selectedProject
    },
    customer() {
      return this.customerStore.selectedCustomer
    },
    user() {
      return this.authStore.user
    }
  },
  methods: {
    changedEvent() {
      this.changed = true
    },
    checkInputs() {
      this.isError = false
      if (!this.newRequest.description) this.isError = true

      if (!this.isError) {
        this.sendRequest()
      }
    },
    sendRequest() {
      this.$store.commit("modals/setWaitingLoader", this.$t("SIMS_SENDING_REQUEST_LOADER"))
      axios
        .post(
          process.env.VUE_APP_APICMS +
            "/forms/newhw?token=" +
            this.user.access_token +
            "&email=" +
            this.apiUser.email +
            "&jmeno=" +
            this.apiUser.firstName +
            "&phone=" +
            this.apiUser.phone +
            "&prijmeni=" +
            this.apiUser.lastName +
            "&customer=" +
            this.customer.customerName +
            "&customerId=" +
            this.customerId +
            "&project=" +
            this.project.projectName +
            "&projectId=" +
            this.projectId,
          this.newRequest
        )
        .then(() => {
          this.$store.commit("modals/setWaitingLoader", "")
          this.setInfo("NEW_HW_REQUEST_SENT")
          this.toggleInfo()
          this.resetRequestModel()
          this.closeBox()
        })
        .catch(() => {
          this.$store.commit("modals/setWaitingLoader", "")
          this.setInfo("SIMS_NEW_REQUEST_ERROR")
          this.toggleInfo()
        })
    },
    closeBox() {
      if (this.opened.indexOf(this.boxName) > -1) {
        this.boxName == undefined ? (this.opened = []) : this.opened.splice(this.opened.indexOf(this.boxName), 1)
      } else {
        this.opened.push(this.boxName)
      }
      this.changed = false
    },
    resetRequestModel() {
      this.newRequest = {
        description: ""
      }
    },
    toggleSaveConfirmation() {
      if (this.changed) {
        this.openedSaveConfirmation = this.openedSaveConfirmation ? false : true
      } else {
        this.openedSaveConfirmation = false
        this.closeBox()
      }
    },
    setInfo(infoText) {
      this.infoText = infoText
    },
    toggleInfo() {
      this.openedInfoConfirmation = this.openedInfoConfirmation ? false : true
    }
  }
}
</script>
